/* eslint-disable */
/* element ui 表单校验辅助函数 */
import { PageModule } from "@/store/module/page";
// 判断数字是否为正整数
export const positivePass = (rule: any, value: number, callback: Function) => {
  if (Number(value) >= 2147483647) {
    callback(new Error("输入数值过大"));
    return;
  }
  if (/[\.-]/.test(String(value)) || value === 0) {
    callback(new Error("请输入正整数"));
  } else {
    callback();
  }
};

// 判断手机验证码是否合法
export const mobileCodePass = (
  rule: any,
  value: number,
  callback: Function
) => {
  if (/^\d{6}$/.test(String(value))) {
    callback();
  } else {
    callback(new Error("请输入6位数字"));
  }
};

// 判断数字是否为非负整数
export const pIntegerPass = (rule: any, value: number, callback: Function) => {
  if (Number(value) >= 2147483647) {
    callback(new Error("输入数值过大"));
    return;
  }
  if (/[\.-]/.test(String(value))) {
    callback(new Error("请输入非负整数"));
  } else {
    callback();
  }
};

// 判断数字是否为合法价格数（正数且小数为两位内）
export const pricePass = (rule: any, value: number, callback: Function) => {
  if (Number(value) >= 2147483647) {
    callback(new Error("输入数值过大"));
    return;
  }
  if (/\.$/.test(String(value))) {
    callback(new Error("请补足小数位"));
  } else if (/-/.test(String(value))) {
    callback(new Error("请输入正数"));
  } else {
    if (/\.\d{3}/.test(String(value))) {
      callback(new Error("请保留两位小数"));
    } else {
      callback();
    }
  }
};
// 判断手机号是否合法
export const phonePass = (rule: any, value: string, callback: Function) => {
  let caches = PageModule.pageInfo.areaCodePhoneNumber.area_code;
  let cache = "86";
  if (caches) {
    cache = caches;
  }
  if (!value) {
    callback();
    return false;
  }
  if (cache !== "86" && cache !== "852" && cache !== "853" && cache !== "886") {
    //国外
    callback();
    return;
  } else if (cache === "853") {
    //澳门
    if (!/^6\d{7}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else if (cache === "852") {
    //香港
    if (!/^[5|6|9]\d{7}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else if (cache === "886") {
    //台湾
    if (!/^09\d{8}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else {
    // 中国大陆
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  }
};
// 监护人判断手机号是否合法
export const guardianPhonePass = (
  rule: any,
  value: string,
  callback: Function
) => {
  let guardianCaches =
    PageModule.pageInfo.guardianAreaCodePhoneNumber.area_code;
  let guardianCache = "86";
  if (guardianCaches) {
    guardianCache = guardianCaches;
  }
  if (!value) {
    callback();
    return false;
  }
  if (
    guardianCache !== "86" &&
    guardianCache !== "852" &&
    guardianCache !== "853" &&
    guardianCache !== "886"
  ) {
    //国外
    callback();
    return;
  } else if (guardianCache === "853") {
    //澳门
    if (!/^6\d{7}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else if (guardianCache === "852") {
    //香港
    if (!/^[5|6|9]\d{7}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else if (guardianCache === "886") {
    //台湾
    if (!/^09\d{8}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  } else {
    // 中国大陆
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(String(value))) {
      callback(new Error("请输入正确的手机号"));
    } else {
      callback();
    }
    return;
  }
};
